import { PostType } from 'src/types/post';

// post can be post, poll, reply and notification
export const getPostLink = (post, type = 'posts'): string => {
  const currentPost = post.superParent || post; // superParent for reply and some notifications
  const postId = currentPost.id;
  const title = currentPost.urlEncodedTitle; //undefined for reply and notification
  const responseId = post.superParent ? post.id : undefined;
  const responses = responseId !== undefined ? `?responses=${responseId}` : '';

  if (currentPost.postTypeId === PostType.Poll && title !== '') {
    return `polls/${postId}/${title}/result`;
  } else {
    return `${type}/${postId}/${title}${responses}`;
  }
};

export const getUrlParamResponses = (post): string => {
  const responseId = 'response' in post && post.response
    ? post.response.id
    : ('superParent' in post && post.superParent ? post.postId : undefined);

  return responseId !== undefined ? `?responses=${responseId}` : '';
};

// works for both posts and replies (and polls and posts). Type post is prepared for newsfeed and profile
export function getPostLinkForSnippet(post, type): string {
  const title = post.urlEncodedTitle;
  const slug = post.community.slug;
  const privateParam = post.isPrivate || post.community.isPrivate ? '/private' : '';

  const currentPost = post.superParent || post;
  const postId = currentPost.postId;
  let responses;

  switch (type) {
    case (PostType.Post || PostType.Poll):
      responses = '';
      break;
    case (PostType.Reply): {
      responses = getUrlParamResponses(post);
      break;
    }
  }

  const parentPostType = currentPost.postTypeId || type;

  if (parentPostType === PostType.Poll) {
    return `/${slug}/polls/${postId}/${title}`; //doesn't scroll to responses + polls don't have a /private param
  } else {
    return `/${slug}/posts${privateParam}/${postId}/${title}${responses}`;
  }
}

export const getPostTypeName = (postTypeId): string => {
  switch (postTypeId) {
    case PostType.Reply: return 'reply';
    case PostType.Post:  return 'post';
    case PostType.Poll:  return 'poll';
    default: return 'post';
  }
};
